/* eslint-disable no-useless-escape */
import React, { useEffect, useState } from 'react';
import { getNameClient } from './../../../helpers/nameClient';
import { useSelector, useDispatch } from 'react-redux';
import PageTitle from '../../../components/Common/MetaTagsHelper/metaTagsHelper';
import { transformObjectKey } from '../../../helpers/tools_helper';
import { Col, Container } from 'reactstrap';
import Swal from 'sweetalert2';

import { ISelector } from '../../../components/Common/iComponents/iSelector/iSelector';
import { IInput } from '../../../components/Common/iComponents/iInput/iInput';

import { getUsers, addUsers, updateUsers, deleteUsers } from '../../../store/Users/actions';
import { getClients } from '../../../store/actions';
import { getRoles } from '../../../store/Roles/actions';

import Breadcrumbs from '../../../components/Common/Breadcrumb/Breadcrumb';
import { ITable } from '../../../components/Common/iComponents/iTable/ITable';
import { IPopUp } from '../../../components/Common/iComponents/iPopUp/IpopUp';
import FormUsers from './form-Users';
import { ISwitch } from '../../../components/Common/iComponents/iSwitch/iSwitch';
import usePageTitle from '../../../common/hooks/usePageTitle';
import moment from 'moment';

const UsersList = (props: any) => {
    const dispatch = useDispatch();
    const { users, CountItems } = useSelector((state: any) => state.Users);
    const { clients } = useSelector((state: any) => state.clients);
    const { roles, CountItems: CountItemsRoles } = useSelector((state: any) => state.Roles);

    const valuesSizeRolesPagination = [10, 20, 30, 40, 50, 100];
    const [paginationRoles] = useState<any>({
        sizePerPage: valuesSizeRolesPagination[0],
        page: 1,
    });

    const PageTitleUSER = usePageTitle(props.location.pathname);

    const [tableViewList] = useState([]);
    const [popUpState, setpopUpState] = useState(false);
    const [updateState, setUpdateState] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);

    const [usersData, setUsersData] = useState([]);

    const valuesSizePagination = [10, 20, 30, 40, 50, 100];
    const [pagination, setPagination] = useState<any>({
        sizePerPage: valuesSizePagination[0],
        page: 1,
    });

    const valuesSizeClientsPagination = [10, 20, 30, 40, 50, 100];
    const [paginationClients, setPaginationClients] = useState<any>({
        sizePerPage: valuesSizeClientsPagination[0],
        page: 1,
    });
    const formatUserData = () => {
        setUsersData([]);
        const newArray = users?.map((item: any) => {
            const newObject = {
                ...item,
                USUARIO_ACTIVO: item?.USUARIO_ACTIVO?.toString(),
                SUB_ENTITIES: [],
            };
            try {
                const Entities = item?.SUB_ENTITIES;
                if (Entities !== null) {
                    newObject.SUB_ENTITIES = JSON?.parse(Entities);
                } else {
                    newObject.SUB_ENTITIES = [];
                }
            } catch (error) {
                newObject.SUB_ENTITIES = item?.SUB_ENTITIES?.replace(/[\[\]"]/g, ' ');
            }
            return newObject;
        });
        setUsersData(newArray);
    };

    /* Filters */

    const textClient = 'Search Client ID';
    const textClientName = 'Search Client';
    const textRol = 'Search Rol Id';
    const textNetworkId = 'Search NetworkId';
    const textName = 'Search Name';
    const textLastName = 'Search Last Name';
    const textEmail = 'Search Email';

    const [queryObject, setQueryObject] = useState<any>({});
    const [queryString, setQueryString] = useState<any>({});

    const initialArrayTableClients = [
        {
            text: 'Id',
            dataField: 'id',
            formatter: (cellContent: any, clients: any) => <>{clients.id}</>,
            hidden: false,
        },
        {
            text: 'Name',
            dataField: 'name',
            formatter: (cellContent: any, clients: any) => <>{clients.name}</>,
            hidden: false,
        },
    ];

    const initialArrayTableRoles = [
        {
            text: 'Id',
            dataField: 'id',
            formatter: (cellContent: any, roles: any) => <>{roles.id}</>,
            hidden: false,
        },
        {
            text: 'Name',
            dataField: 'nombre',
            formatter: (cellContent: any, roles: any) => <>{roles.nombre}</>,
            hidden: false,
        },
    ];

    const initialArrayTable = [
        {
            text: 'ID',
            dataField: 'id',
            formatter: (cellContent: any, users: any) => <>{users.id}</>,
            hidden: false,
        },
        {
            text: 'NETWORK ID',
            dataField: 'NETWORK_ID',
            formatter: (cellContent: any, users: any) => <>{users.NETWORK_ID}</>,
            hidden: false,
        },
        {
            text: 'CREATED AT',
            dataField: 'createdAt',
            formatter: (cellContent: any, users: any) => <>{moment(users.createdAt).format('YYYY-MM-DD HH:mm:ss')}</>,
            sort: true,
        },
        {
            text: 'UPDATED AT',
            dataField: 'updatedAt',
            formatter: (cellContent: any, users: any) => <>{moment(users.updatedAt).format('YYYY-MM-DD HH:mm:ss')}</>,
            sort: true,
        },
        {
            text: 'NAME',
            dataField: 'USUARIO_NOMBRE',
            formatter: (cellContent: any, users: any) => <>{users.USUARIO_NOMBRE}</>,
            hidden: false,
        },
        {
            text: 'LAST NAME',
            dataField: 'USUARIO_APELLIDO',
            formatter: (cellContent: any, users: any) => <>{users.USUARIO_APELLIDO}</>,
            hidden: false,
        },
        {
            text: 'EMAIL',
            dataField: 'USUARIO_CORREO',
            formatter: (cellContent: any, users: any) => <>{users.USUARIO_CORREO}</>,
            hidden: false,
        },
        {
            text: 'ACTIVE',
            dataField: 'USUARIO_ACTIVO',
            formatter: (cellContent: any, users: any) => {
                const activeUser = users.USUARIO_ACTIVO === 'true';
                const keyMapping = {
                    USUARIO_NOMBRE: 'USER_NAME',
                    USUARIO_APELLIDO: 'USER_LAST_NAME',
                    USUARIO_PASSWORD: 'USER_PASSWORD',
                    USUARIO_CORREO: 'USER_EMAIL',
                    ROL_ID: 'ROLE_ID',
                    EMPRESA_ID: 'COMPANY_ID',
                    USUARIO_ACTIVO: 'USER_ACTIVE',
                };
                let newObject = { ...users };
                newObject = transformObjectKey(newObject, keyMapping);
                return (
                    <ISwitch
                        checked={activeUser}
                        onChangeBooleanHandler={(args:any) => {
                            newObject.USER_ACTIVE = String(args);
                            dispatch(
                                updateUsers({
                                    users: newObject,
                                    pagination,
                                    filter: queryString,
                                }),
                            );
                        }}
                    />
                );
            },
            hidden: false,
        },
        {
            text: 'ROL',
            dataField: 'ROL_ID',
            formatter: (cellContent: any, users: any) => <>{users.ROL_ID}</>,
            hidden: false,
        },
        {
            text: 'INNOBOKEY',
            dataField: 'INNOBOKEY',
            formatter: (cellContent: any, users: any) => <>{users.INNOBOKEY === 'null' ? '' : users.INNOBOKEY}</>,
            hidden: false,
        },
        {
            text: 'SUB ENTITIES',
            dataField: 'SUB_ENTITIES',
            formatter: (cellContent: any, users: any) => <>{users.SUB_ENTITIES.join('; ')}</>,
            hidden: false,
        },
    ];

    useEffect(() => {
        dispatch(getRoles({ pagination: paginationRoles }));
        dispatch(getClients({}));
    }, [dispatch, paginationRoles]);

    useEffect(() => {
        const queryTextName = queryString[textName];
        const queryTextLastName = queryString[textLastName];
        const queryTextEmail = queryString[textEmail];

        let userConsultName = false;
        let userConsultLastName = false;
        let userConsultEmail = false;

        if (queryTextName !== undefined ? (queryTextName.length > 3 && queryTextName.length > 0) || queryTextName === '' : true) {
            userConsultName = true;
        }
        if (queryTextLastName !== undefined ? (queryTextLastName.length > 3 && queryTextLastName.length > 0) || queryTextLastName === '' : true) {
            userConsultLastName = true;
        }
        if (queryTextEmail !== undefined ? (queryTextEmail.length > 3 && queryTextEmail.length > 0) || queryTextEmail === '' : true) {
            userConsultEmail = true;
        }

        if (userConsultName && userConsultLastName && userConsultEmail) {
            formatUserData();
            dispatch(getUsers({ pagination, filter: queryString }));
        }
    }, [dispatch, pagination, queryString]);

    useEffect(() => {
        formatUserData();
    }, [users]);

    const handleCreateUsers = (users: any) => {
        setpopUpState(!popUpState);
        dispatch(addUsers({ users, pagination }));
        Swal.fire({
            icon: 'success',
            title: 'Added!!!',
            text: 'New items have been added successfully!!!',
        });
    };

    const handleUpdateUsers = (users: any) => {
        setpopUpState(!popUpState);
        dispatch(updateUsers({ users, pagination, filter: queryString }));
        Swal.fire({
            icon: 'success',
            title: 'Updated!!!',
            text: 'New items have been updated successfully!!!',
        });
    };

    const handleDeleteUsers = (id: any) => {
        setpopUpState(!popUpState);
        dispatch(deleteUsers({ id, pagination }));
        Swal.fire({
            icon: 'success',
            title: 'Deleted!!!',
            text: 'Items have been deleted successfully!!!',
        });
    };

    const handleCancel = (id: any) => {
        setpopUpState(!popUpState);
    };

    const onPopUpState = () => {
        setpopUpState(!popUpState);
    };

    const handleActionOnRowClick = (row: any) => {
        setSelectedRow(row);
    };

    const handleAddAction = () => {
        setUpdateState(false);
        setpopUpState(!popUpState);
        setSelectedRow(null);
    };

    const handlePaginationChange = (newState: any) => {
        setPagination(newState);
    };

    const handlePaginationClientsChange = (newState: any) => {
        setPaginationClients(newState);
    };
    const onChangeSelectorHandler = (n: any, value: any) => {
        setQueryString({ ...queryString, [n]: value.id });
        setQueryObject({ ...queryObject, [n]: value });
    };

    const onChangeHandler = (e: any, n: any) => {
        if (n === 'Search Client ID') {
            const newObject = clients.filter((item: any) => Number(item.id) === Number(e.target.value))[0];
            setQueryObject({ ...queryObject, [n]: newObject });
        }

        if (n === 'Search Rol Id') {
            const newObject = roles.filter((item: any) => Number(item.id) === Number(e.target.value))[0];
            setQueryObject({ ...queryObject, [n]: newObject });
        }

        setQueryString({ ...queryString, [n]: e.target.value });
    };

    const AdminFilters = () => {
        return (
            <>
                <div className="col-4">
                    <div className="justify-content-center">
                        <ISelector
                            title={textClient}
                            titleSearch={textClientName}
                            value={queryObject[textClient]?.id || queryString[textClient] || ''}
                            nameSelector={queryObject[textClient]?.name ?? ''}
                            valuesSizePagination={valuesSizeClientsPagination}
                            CountItems={clients?.length}
                            dataSelector={clients}
                            initialArrayTable={initialArrayTableClients}
                            handlePaginationChange={handlePaginationClientsChange}
                            setSelectedRow={onChangeSelectorHandler}
                            onChangeHandler={onChangeHandler}
                        />
                    </div>
                </div>
                <div className="col-4">
                    <div className="justify-content-center">
                        <ISelector
                            title={textRol}
                            value={queryObject[textRol]?.id || queryString[textRol] || ''}
                            nameSelector={queryObject[textRol]?.nombre ?? ''}
                            valuesSizePagination={valuesSizeClientsPagination}
                            CountItems={CountItemsRoles}
                            dataSelector={roles}
                            initialArrayTable={initialArrayTableRoles}
                            handlePaginationChange={handlePaginationClientsChange}
                            setSelectedRow={onChangeSelectorHandler}
                            onChangeHandler={onChangeHandler}
                        />
                    </div>
                </div>
                <div className="col-4">
                    <div className="justify-content-center">
                        <IInput title={textNetworkId} type={'number'} value={queryString[textNetworkId]} onChangeHandler={onChangeHandler} />
                    </div>
                </div>
                <div className="col-4 pt-1">
                    <div className="justify-content-center">
                        <IInput title={textName} type={'text'} value={queryString[textName]} onChangeHandler={onChangeHandler} />
                    </div>
                </div>
                <div className="col-4 pt-1">
                    <div className="justify-content-center">
                        <IInput title={textLastName} type={'text'} value={queryString[textLastName]} onChangeHandler={onChangeHandler} />
                    </div>
                </div>
                <div className="col-4 pt-1">
                    <div className="justify-content-center">
                        <IInput title={textEmail} type={'text'} value={queryString[textEmail]} onChangeHandler={onChangeHandler} />
                    </div>
                </div>
            </>
        );
    };

    return (
        <React.Fragment>
            <div id="main" style={{ overflow: 'auto' }}>
                <div id="navbar"></div>
                <div className="pageContent">
                    <PageTitle>
                        <title>
                            {PageTitleUSER.replace(/-/g, ' ')} | {getNameClient()}
                        </title>
                    </PageTitle>
                    <Container fluid>
                        <div className="row justify-content-end me-2">
                            <div className="d-flex justify-content-end pb-3">
                                <button type="button" className="btn bg-primary text-white add-primary-button" onClick={handleAddAction}>
                                    + Add
                                </button>
                            </div>
                            {AdminFilters()}
                        </div>

                        <Col lg="12">
                            <ITable
                                valuesSizePagination={valuesSizePagination}
                                CountItems={CountItems}
                                remote={false}
                                data={usersData}
                                fields={initialArrayTable}
                                tableColumns={initialArrayTable}
                                pagSize={4}
                                pageStartIn={0}
                                showTotal={true}
                                disablePageTitle={true}
                                headerColorT={'bg-primary text-white'}
                                tableViewList={tableViewList}
                                groupName=""
                                handlePopUpState={onPopUpState}
                                actionOnRowClick={handleActionOnRowClick}
                                handlerPaginationState={handlePaginationChange}
                            />
                        </Col>
                    </Container>
                </div>
            </div>
            <IPopUp
                stateAdd={popUpState}
                switchStateAdd={setpopUpState}
                stateUpdate={updateState}
                switchStateUpdate={setUpdateState}
                modalTitleAdd={'Users'}
                modaleTitleUpdate={'Update Users'}
                icon="users"
                colorHeaderPop={'#101340'}
            >
                <FormUsers
                    selectedRow={selectedRow}
                    onCreateUser={handleCreateUsers}
                    onUpdateUser={handleUpdateUsers}
                    onDeleteUser={handleDeleteUsers}
                    onCancel={handleCancel}
                />
            </IPopUp>
        </React.Fragment>
    );
};

export default UsersList;
